let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f4Pg6")).then(() => parcelRequire('47dkS'));